import { Action } from '@reduxjs/toolkit';
import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';

import { Button, ButtonTypes, LinkButton } from '@eika/button';
import { InfoCard } from '@eika/card';
import { Modal } from '@eika/modal';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { meldSkadeNamespace } from '../../index';
import { RemoteData, RemoteDataType } from '../../reducers/remoteData';
import { BesvartSporsmal } from '../../sporsmalsflyt/reducer/current-steg';
import { updateWithBesvarteSporsmalFromCacheAction } from '../../sporsmalsflyt/reducer/sporsmalsflyt-actions';
import { fixSerializedSporsmal } from './besvarteSporsmal';

import './besvarteSporsmal-modal.scss';

interface BesvarteSporsmalProps {
    openModal: boolean;
    setOpen: () => void;
    besvarteSporsmal: RemoteData<BesvartSporsmal[]>;
    closeModal: () => void;
}

export const BesvarteSporsmalModal: FC<BesvarteSporsmalProps> = ({
    openModal,
    setOpen,
    besvarteSporsmal,
    closeModal,
}) => {
    const dispatch: Dispatch<Action> = useDispatch();

    const onYesClick = () => {
        if (besvarteSporsmal.type === RemoteDataType.SUCCESS) {
            dispatch(updateWithBesvarteSporsmalFromCacheAction(besvarteSporsmal.data.map(fixSerializedSporsmal)));
            closeModal();
        }
    };

    return (
        <Modal
            appNamespace={meldSkadeNamespace}
            id="besvarte-sporsmal-modal"
            open={openModal}
            setOpen={setOpen}
            onClose={closeModal}
        >
            <InfoCard skipBackground>
                <RichIcon type={RichIconTypes.HAAND_HEIHEI} />
                <h1 className="light">Du har en påstartet skademelding</h1>
                <p>Vil du fortsette utfyllingen der du slapp?</p>
            </InfoCard>
            <div className="besvart-sporsmal-modal-button-container">
                <LinkButton onClick={closeModal}>Nei, start på nytt</LinkButton>
                <Button buttonType={ButtonTypes.STANDARD_POSITIVE} onClick={onYesClick}>
                    Ja, fortsett utfylling
                </Button>
            </div>
        </Modal>
    );
};
export default BesvarteSporsmalModal;
